// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import * as DmsService from './../supports/dms-service';
import * as DmsCommon from '../supports/dms-common';
import { GlobalEvent, GlobalState } from './GlobalContext'
import DocTypeTab from './DocTypeTab';
import FolderStructureTab from './FolderStructureTab';
import FolderPermissionTab from './FolderPermissionTab';
import FolderAdminTab from './FolderAdminTab';
import ReportTab from './ReportTab';
import UserTab from './UserTab';
import UserGroupTab from './UserGroupTab';
import MsgDialog from './MsgDialog';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function MaintenanceDialog(props) {

  const theme = useTheme();

  const { open, onClose, sysID, folders } = props;
  const adminFolders = props.adminFolders || [];

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const curDept = gState?.depts?.find(d => d.DeptCode == sysID);
  const adminLevel = curDept?.AdminLevel || 0;
  const isDataAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData);
  const isSecurtyAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity);
  const hasFolderStruct = (isDataAdmin || (adminFolders.length > 0));
  const hasFolderPerm = (isSecurtyAdmin || (adminFolders.length > 0));

  const [hasUpdate, setHasUpdate] = useState(false);

  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };



  useEffect(() => {

    const xFunc = async () => {
      if (open) {

        setHasUpdate(false);

        let vShowTabValue = -1;
        if (isDataAdmin === true) {
          vShowTabValue = 0;
        } else if (hasFolderStruct === true) {
          vShowTabValue = 1;
        } else if (hasFolderPerm === true) {
          vShowTabValue = 2;
        } else if (isSecurtyAdmin === true) {
          vShowTabValue = 3;
        }


        // console.log("vShowTabValue", vShowTabValue);

        setValue(vShowTabValue);
        //   })
      }
    }
    xFunc();


  }, [open]);

  const handleCloseClick = () => {
    // console.log("MaintenanceDialog handleCloseClick", hasUpdate);
    onClose && onClose(hasUpdate);

  }

  const handleAfterUpdated = () => {
    console.log("handleAfterUpdated");
    setHasUpdate(true);
  }

  return (
    <React.Fragment>


      <Dialog
        fullWidth={true}
        maxWidth={"xl"}
        open={open}
        scroll="paper"
        aria-describedby="dialog-maintenance"

        PaperProps={{
          sx: {
            display: 'flex',
            minHeight: "90vh",
            maxHeight: "90vh",
          }
        }}
      >
        <DialogContent dividers={scroll === 'paper'}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <MsgDialog
            open={showError}
            title="Error"
            msgText={errMsg}
            onClose={() => setShowError(false)}
          />

          <Box sx={{
            width: '100%',
            // height: 100,
            bgcolor: 'background.paper',
            // display: 'flex',
            // height: '100vh',
            // flex: 1,
            // bgcolor: 'grey.300',
          }}>

            <Tabs
              value={value}
              onChange={handleTabChange}

              variant="scrollable"
              scrollButtons="auto"
            >
              {isDataAdmin &&
                <Tab label="Document Types" value={0} {...a11yProps(0)} />
              }

              {hasFolderStruct &&
                <Tab label="Folder Structure" value={1} {...a11yProps(1)} />
              }

              {hasFolderPerm &&
                <Tab label="Folder Permission" value={2} {...a11yProps(2)} />
              }

              {isSecurtyAdmin &&
                <Tab label="Users" value={3} {...a11yProps(3)} />
              }

              {isSecurtyAdmin &&
                <Tab label="User Groups" value={4} {...a11yProps(4)} />
              }

              {isSecurtyAdmin &&
                <Tab label="Folder Admins" value={5} {...a11yProps(5)} />
              }

              {(isDataAdmin || isSecurtyAdmin) &&
                <Tab label="Report" value={6} {...a11yProps(6)} />
              }

            </Tabs>

            <TabPanel value={value} index={0} dir={theme.direction}>
              <DocTypeTab sysID={sysID} />
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <FolderStructureTab sysID={sysID} onUpdate={handleAfterUpdated} />
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              <FolderPermissionTab sysID={sysID} onUpdate={handleAfterUpdated} />
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              <UserTab sysID={sysID} />
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction}>
              <UserGroupTab sysID={sysID} onUpdate={handleAfterUpdated} />
            </TabPanel>
            <TabPanel value={value} index={5} dir={theme.direction}>
              <FolderAdminTab sysID={sysID} onUpdate={handleAfterUpdated} />
            </TabPanel>
            <TabPanel value={value} index={6} dir={theme.direction}>
              <ReportTab sysID={sysID} folders={folders} />
            </TabPanel>


          </Box>



        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClick} >Close</Button>
        </DialogActions>
      </Dialog>

    </React.Fragment>


  );
}

MaintenanceDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  folders: PropTypes.array,
  adminFolders: PropTypes.array,
};

export default MaintenanceDialog